import { OrderVersionData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';

export const orderVersionsApi = apiResource<OrderVersionData>('order-versions');
